import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M18 6v6a3 3 0 0 1 -3 3h-10l4 -4m0 8l-4 -4","key":"svg-0"}]]

/**
 * IconCornerDownLeft
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY29ybmVyLWRvd24tbGVmdCIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMTggNnY2YTMgMyAwIDAgMSAtMyAzaC0xMGw0IC00bTAgOGwtNCAtNCIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/corner-down-left
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconCornerDownLeft = createReactComponent('outline', 'corner-down-left', 'CornerDownLeft', __iconNode);

export default IconCornerDownLeft;